import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import styles from './ViewFeedbackDetails.module.css';
import { Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Button as MuiButton, CircularProgress } from '@mui/material';
import useModal from '../../../hooks/useModal';
import ShowResolverInfoModal from '../../basic-component/Modal/ShowResolverInfoModal';
import useAxiosFetchData from '../../../hooks/useAxiosFetchData';
// import { apiHostUrl, getUserListfromGroupName } from '../../../../constants/constants';
import { useSelector } from 'react-redux';
import ViewFeedbackDetails from './ViewFeedbackDetails';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import useDialog from '../../../hooks/useAddModal';
import { apiHostUrl, fileDownloadUrl, getCustomerFeedbackDetailsURL, getUserlistfromGroupName, skeleton_animation_style_primary } from '../../../../constants/constants';
import CustomerResponsePopup from "./CustomerResponsePopup";
import CommentDetails from "./CommentDetails";
import PluginSnackbar from "../../basic-component/Snackbar";

// Bootstrap
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { CardBody } from 'react-bootstrap';
import CustomerSatisfaction from './CustomerSatisfaction';
import { generateAppropriateDate, generateAppropriateDateWithConsent } from '../../basic-component/DateUtils';
import ReactModal from '../../basic-component/Modal/AddModalCustomer';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976D2', // Adjust color as needed
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif', // Adjust font family as needed
  },
});

const FeedBackDetails = ({
  data,
  handleFeedbackAction,
  taggedFeedbackAction,
  handleConsentAction,
  consent,
  handleConsentActiontagged,
  onClick,
  resolutionToggle,
  customerSatisfactionStarResponse,
  reciptToggle,
  sladetailstoggle,
  closeFd,
  handleMailData,
  fetchfeedbackDetails,
  onConsentSubmit,
}) => {
  const { t } = useTranslation();

  const { homeLink } = useSelector((state) => state.role);
  const role = useSelector((state) => state.role.roles);
  const { userCurrRole } = useSelector((state) => state.role);
  const { userId } = useSelector((state) => state.role);
  const getUserListfromGroupNameUrl =
    apiHostUrl + homeLink + getUserlistfromGroupName;
  const fileDownloadURL = apiHostUrl + homeLink + fileDownloadUrl;
  // const { homeLink } = useSelector((state) => state.role);
  const { value: customerStatisfactionStored } = useSelector(
    (state) => state.reloadFeedbackDetails
  );
  // const urlGroupName = apiHostUrl + homeLink + getUserlistfromGroupName;
  console.log(data?.receiptDetails);
  const [customerResponseFormData, setCustomerResponseFormData] = useState({
    feedback_id: ""
  });
  const [userListFormData, setUserListFormData] = useState({
    id: "",
    department: {
      id: "",
    },
    id: "",
  });
  // data?.feedbackDetails?.department?.id
  // Update userListFormData when data changes

  useEffect(() => {
    console.log(customerStatisfactionStored);
  }, [customerStatisfactionStored]);
  useEffect(() => {
    setUserListFormData((prevState) => ({
      ...prevState,

      department: {
        id: data?.feedbackDetails?.department?.id,
      },
      id: data?.receiptDetails[0]?.assigneeGroup?.id,
    }));
  }, [data]);
  const getCommentDetailsList = () => {
    const dataList = Array.isArray(data?.commentDetails) ? data.commentDetails : [];
    const consentList =
      consent?.success && Array.isArray(consent?.commentDetails) ? consent.commentDetails : [];
    const source = consentList.length >= dataList.length ? consentList : dataList;
    return source.filter(
      (item, index, self) => self.findIndex((t) => t.id === item.id) === index
    );
  };

  const getChatCommentItems = () => {
    return [...getCommentDetailsList()].sort(
      (a, b) => new Date(a.createDate) - new Date(b.createDate)
    );
  };
  const { csrfToken } = useSelector((state) => state.csrf);
  const [headers, setHeaders] = useState({
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  // const [row, setRow] = useState([]);
  const { fetchData: userListFeedbackResponse } = useAxiosFetchData({
    url: getUserListfromGroupNameUrl,
    method: "post",
    body: userListFormData,
    headers: headers,
    onLoad: false,
  });
  // useEffect(() => {
  //   if (userListFormData?.department.id) {

  //     userListFeedbackResponse().then((data) => {
  //       console.log(data)
  //     })
  //   }
  // }, [userListFormData])

  // console.log(userListFeedbackResponse);

  const handleAssigneeView = (e) => {
    if (userListFormData?.department.id) {
      userListFeedbackResponse().then((data) => {
        console.log(data);
        setRow(data);
      });
    }
    toggle();
  };
  const [feedbackCode, setFeedbackCode] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [feedbackGivenBy, setFeedbackGivenBy] = useState("");
  const [emailId, setEmailId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [dateOfFeedback, setDateOfFeedback] = useState("");
  const [feedbackDescription, setFeedbackDescription] = useState("");
  const { isShowing, toggle } = useModal({ state: false });
  const { isOpen, toggleModal } = useDialog();
  const [feedbackDetail, setFeedbackDetails] = useState("");
  const [tagged, setTaggedFeedback] = useState("");
  const [row, setRow] = useState([]);
  const [selectedTaggedFeedbackId, setSelectedTaggedFeedbackId] =
    useState(null); // State for selected feedback ID
  const [showRate, setRate] = useState(false);
  const roles = useSelector((state) => state.role.userCurrRole.description);
  const rolesId = useSelector((state) => state.role.userCurrRole.id);
  const [showConsent, setShowConsent] = useState(true);
  const [showCustomerConsent, setShowCustomerConsent] = useState(true);
  const [reopenReasonList, setReopenReasonList] = useState([]);
  const [showResolution, setShowResolution] = useState(true);
  const [showAssigneGroup, setShowAssigneGroup] = useState(true);
  const [client, setClient] = useState([]);
  const [clientVal, setClientVal] = useState("");

  const [feedbackSource, setFeedbackSource] = useState("");
  const [showRecipt, setShowRecipt] = useState("");
  const [showSla, setShowSla] = useState("");
  const [showResolutionBackend, setShowResolutionBackend] = useState("");

  console.log(roles);
  useEffect(() => {
    debugger;
    if (roles === "ROLE_CUSTOMER" || roles === "ROLE_INTERNAL") {
      setShowConsent(false);
      if (roles === "ROLE_CUSTOMER"){
      setShowCustomerConsent(true);}
    } else {
      setShowConsent(true);
      setShowCustomerConsent(false);
    }
  }, [roles]);
  useEffect(() => {
    debugger;
    if (roles === "ROLE_CUSTOMER" || roles === "ROLE_INTERNAL") {
      setShowResolution(false);
      setShowAssigneGroup(false);
    } else {
      setShowResolution(true);
      setShowAssigneGroup(true);
    }
  }, [data]);
  useEffect(() => {}, [showResolution]);
  console.log(roles);
  console.log("hi" + data);
  // const generateAppropriateDate = (value) => {
  //   if (value === undefined || value === null) {
  //     return "N/A";
  //   } else {
  //     const date = new Date(value);
  //     const formattedDate = date.toLocaleString('en-GB', {
  //       day: '2-digit',
  //       month: '2-digit',
  //       year: '2-digit',
  //       hour: '2-digit',
  //       minute: '2-digit',
  //     });

  //     return formattedDate;
  //   }
  // };

  const handleTaggedFeedbackClick = (id) => {
    console.log(id);
    // taggedFeedbackAction(id);
    // setSelectedTaggedFeedbackId(id);
    onClick(id);
  };

  const generateTaggedFeedbacks = () => {
    if (
      typeof data.taggedFeedbackList !== "undefined" &&
      data.taggedFeedbackList.length > 0
    ) {
      return data.taggedFeedbackList.map((feedback, index) => (
        <React.Fragment key={feedback.id}>
          <span
            onClick={() => handleTaggedFeedbackClick(feedback.id)}
            className="cursor-pointer"
          >
            {feedback.feedbackCode}
          </span>
          {index !== data.taggedFeedbackList.length - 1 && ", "}
        </React.Fragment>
      ));
    }
    return t("general.label.notagged.feedback");
  };

  const rateNow = () => {
    console.log("customer");
    setRate(true);
  };
  const [rateCheck, setRateCheck] = useState(false);
  var fdbckTyp = null;
  var feedbackState = null;
  //debugger;
  useEffect(() => {
    if (data && data.feedbackDetails && data.feedbackDetails.user) {
      const stringifiedData = data;
      const createDate = stringifiedData?.feedbackDetails?.createDate || "";
      const parsedDate = createDate ? new Date(createDate) : "";
      debugger;
      setCustomerResponseFormData((prevState) => ({
      ...prevState,
      feedback_id: stringifiedData?.feedbackDetails?.id || "",
      feedbackCode: stringifiedData?.feedbackDetails?.feedbackCode || ""
      }));
      setFeedbackCode(stringifiedData?.feedbackDetails?.feedbackCode || "");
      feedbackState = stringifiedData?.feedbackDetails?.status || null;
      fdbckTyp =
        stringifiedData?.feedbackDetails?.feedbackType?.description || null;
      setCurrentStatus(stringifiedData?.feedbackDetails?.status || "");
      setFeedbackType(
        stringifiedData?.feedbackDetails?.feedbackType?.description || ""
      );
      setOrganizationName(
        stringifiedData?.feedbackDetails?.user?.orgName || ""
      );
      setFeedbackGivenBy(
        stringifiedData.feedbackDetails.user.firstName +
          " " +
          stringifiedData.feedbackDetails.user.lastName
      );
      setEmailId(stringifiedData?.feedbackDetails?.user?.email || "");
      setMobileNumber(stringifiedData?.feedbackDetails?.user?.mobile || "");
      setPhoneNumber(stringifiedData?.feedbackDetails?.user?.phone || "");
      setAddress(stringifiedData?.feedbackDetails?.user?.addressLine || "NA");
      setCreatedBy(stringifiedData?.feedbackDetails?.creator?.username || "");
      setDateOfFeedback(generateAppropriateDate(parsedDate));
      setFeedbackDescription(
        stringifiedData?.feedbackDetails?.description || ""
      );
      setReopenReasonList(stringifiedData?.reopenReasonList);
      setClient(stringifiedData?.attributeList || "");
      // setClientVal(stringifiedData?.attributeList[0]?.attributeVal || "");
      setFeedbackSource(
        stringifiedData?.feedbackDetails?.feedbackSource?.description || ""
      );
      setShowRecipt(
        stringifiedData?.feedbackDetails?.tabVisibilityMap["Receipt Details"]
      );
      setShowSla(
        stringifiedData?.feedbackDetails?.tabVisibilityMap["SLA Details"]
      );
      setShowResolutionBackend(
        stringifiedData?.feedbackDetails?.tabVisibilityMap["Resolution Details"]
      );
      debugger;
    } else if (data && data.feedbackDetails) {
      const stringifiedData = data;
      feedbackState = stringifiedData?.feedbackDetails?.status || null;
      fdbckTyp =
        stringifiedData?.feedbackDetails?.feedbackType?.description || null;
      const createDate = stringifiedData?.feedbackDetails?.createDate || "";
      const parsedDate = createDate ? new Date(createDate) : "";
      setFeedbackCode(stringifiedData?.feedbackDetails?.feedbackCode || "");
      setCurrentStatus(stringifiedData?.feedbackDetails?.status || "");
      setFeedbackType(
        stringifiedData?.feedbackDetails?.feedbackType?.description || ""
      );
      setCreatedBy(stringifiedData?.feedbackDetails?.creator?.username || "");
      setDateOfFeedback(generateAppropriateDate(parsedDate));
      setFeedbackDescription(stringifiedData.feedbackDetails.description || "");
      setOrganizationName(
        stringifiedData?.feedbackDetails.organizationName || ""
      );
      setEmailId(stringifiedData?.feedbackDetails.emailId || "");
      setReopenReasonList(
        stringifiedData?.reopenReasonList[0]?.feedbackSatisfaction
      );
    } else if (data && data.id) {
      const stringifiedData = data;
      const createDate = stringifiedData?.createDate || "";
      const parsedDate = createDate ? new Date(createDate) : "";
      feedbackState = stringifiedData?.status || null;
      fdbckTyp = stringifiedData?.feedbackType?.description || null;
      setFeedbackCode(stringifiedData?.feedbackCode || "");
      setCurrentStatus(stringifiedData?.status || "");
      setFeedbackType(stringifiedData?.feedbackType?.description || "");
      setOrganizationName(stringifiedData?.organizationName || "");
      setFeedbackGivenBy(
        stringifiedData.createFirstName + " " + stringifiedData.createLastName
      );
      setEmailId(stringifiedData?.emailId || "");
      setMobileNumber(stringifiedData?.mobileNo || "");
      setPhoneNumber(stringifiedData?.phoneNo || "");
      setAddress(stringifiedData?.user?.addressLine || "NA");
      setCreatedBy(
        stringifiedData?.feedbackUserFirstName +
          " " +
          stringifiedData?.feedbackUserLastName
      );
      setDateOfFeedback(generateAppropriateDate(parsedDate));
      setFeedbackDescription(stringifiedData.feedbackDesc || "");
      setTaggedFeedback(stringifiedData?.taggedFeedbackList || "");
      setReopenReasonList(
        stringifiedData?.reopenReasonList[0]?.feedbackSatisfaction
      );
    }
    //console.log(data?.reopenReasonList[0]?.feedbackSatisfaction?.id);
    //console.log(data?.feedbackDetails.tabVisibilityMap["Customer Satisfaction"]);
    //alert(fdbckTyp + "==" + feedbackState);
    if (
      (["role_customer", "role_internal", "role_cst"].includes(
        roles.toLowerCase()
      ) ||
        ((userCurrRole.department.id === 112 ||
          userCurrRole.department.id === 189) &&
          ["role_spoc"].includes(roles.toLowerCase()))) &&
      fdbckTyp?.toLowerCase() === "complaint" &&
      (feedbackState?.toLowerCase() === "resolved" ||
        feedbackState?.toLowerCase() === "open with cs team" ||
        feedbackState?.toLowerCase() === "reopened with cs team")
    ) {
      setRateCheck(true);
    } else {
      setRateCheck(false);
    }
    if (
      !["role_customer", "role_internal"].includes(roles.toLowerCase()) &&
      !["new"].includes(feedbackState?.toLowerCase())
    ) {
      setShowAssigneGroup(true);
    } else {
      setShowAssigneGroup(false);
    }
    console.log(feedbackState?.toLowerCase());
    debugger;
    if (
      !["role_customer", "role_internal"].includes(roles.toLowerCase()) &&
      [
        "resolved",
        "reopened",
        "closed",
        "open with cs team",
        "reopened with cs team",
      ].some(keyword=>feedbackState?.toLowerCase().replace(/&/g, '').replace(/\s+/g, ' ').trim().includes(keyword))
    ) {
      setShowResolution(true);
    } else {
      setShowResolution(false);
    }

    console.log(roles);
    // console.log(reason?.feedbackSatisfaction?.id
  }, [data]);

  // const [rateCheck, setRateCheck] = useState(data?.feedbackDetails.tabVisibilityMap["Customer Satisfaction"]);
  // useEffect(() => {
  //   if (data?.feedbackDetails.tabVisibilityMap["Customer Satisfaction"]) {
  //     setRateCheck(true);
  //   }
  // }, [currentStatus]);
  const getStatus = (currentStatus) => {
    switch (currentStatus) {
      case "Work In Progress":
        return "wip";
      case "New":
        return "new";
      case "Active":
        return "wip";
      case "Assigned":
        return "wip";
      case "Accepted":
        return "wip";
      case "Close":
        return "closed";
      case "Resolved":
        return "resolved";
      case "Closed":
        return "closed";
      case "Overdue":
        return "overdue";
      case "Reopened":
        return "reopened";
      default:
        return "overdue";
    }
  };
  const getStar = (currentStatus) => {
    switch (currentStatus) {
      case "ONE STAR":
        return 1;
      case "TWO STAR":
        return 2;
      case "THREE STAR":
        return 3;
      case "FOUR STAR":
        return 4;
      case "FIVE STAR":
        return 5;
      default:
        return 0; // Return 0 or handle invalid cases appropriately
    }
  };

  const getRole = (role) => {
    switch (role) {
      case "ROLE_CST":
        return "cst";
      case "ROLE_CCP":
        return "";
      case "ROLE_SPOC":
        return "spoc";
      case "ROLE_EMU":
        return "";
      case "Role_CUSTOMER":
        return "customer";
      default:
        return "spoc";
    }
  };
  console.log(reopenReasonList);
  const handleClick = () => {
    // Call the function passed from the parent component
    handleFeedbackAction();
  };
  const ConsentComment = () => {
    debugger;
    handleConsentAction();
  };
  const ConsentCommenttagged = (id) => {
    console.log(id);
    handleConsentActiontagged(id);
  };
  const [stars, setStars] = useState([]);
  useEffect(() => {
    if (reopenReasonList !== null && reopenReasonList !== undefined) {
      for (
        let i = 0;
        i < (reopenReasonList.id !== undefined ? reopenReasonList.id : 0);
        i++
      ) {
        setStars((prev) => [
          ...prev,
          <i
            className="ti ti-star-filled orange-color icon-small fs-6 me-1"
            key={i}
          ></i>,
        ]);
      }
    }
  }, [reopenReasonList]);
  const handleClickResolution = () => {
    resolutionToggle();
  };
  const handleClickRecipt = () => {
    reciptToggle();
  };
  const handleCustomerSatisfactionStar = () => {
    customerSatisfactionStarResponse();
  };
  const handleSladetails = () => {
    sladetailstoggle();
  };
  const handleCloseFD = () =>{
    closeFd();
  }

   const [showPopup, setShowPopup] = useState(false);

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Chat modal state
  const [showChatModal, setShowChatModal] = useState(false);
  const [chatConsentTagged, setChatConsentTagged] = useState(true);
  const [chatConsentId, setChatConsentId] = useState("");
  const [commentFormKey, setCommentFormKey] = useState(0);
  const [commentFormState, setCommentFormState] = useState({ isSubmitting: false, canSubmit: false });
  const [chatToast, setChatToast] = useState({ open: false, message: "", severity: "success" });
  const commentFormRef = useRef(null);
  const chatEndRef = useRef(null);

  const openChatModal = () => {
    setChatConsentTagged(true);
    setChatConsentId("");
    setCommentFormState({ isSubmitting: false, canSubmit: false });
    setShowChatModal(true);
  };

  const openChatModalForConsent = (id) => {
    setChatConsentTagged(false);
    setChatConsentId(id);
    setCommentFormState({ isSubmitting: false, canSubmit: false });
    setShowChatModal(true);
  };

  const closeChatModal = () => {
    setShowChatModal(false);
    setCommentFormState({ isSubmitting: false, canSubmit: false });
  };

  const handleChatConsentSubmit = (responseData) => {
    if (responseData?.success) {
      setChatConsentTagged(true);
      setChatConsentId("");
      setCommentFormKey((prev) => prev + 1);
      setChatToast({ open: true, message: t("general.label.comment.submitted") || "Comment submitted successfully!", severity: "success" });
      if (fetchfeedbackDetails) {
        fetchfeedbackDetails();
      }
    } else {
      setChatToast({ open: true, message: t("general.exception.errorMessage") || "Something went wrong. Please try again.", severity: "error" });
    }
    if (onConsentSubmit) {
      onConsentSubmit(responseData, { skipModalToggle: true });
    }
  };

  const handleCommentFormStateChange = (state) => {
    setCommentFormState(state);
  };

  const handleChatFormSubmit = () => {
    commentFormRef.current?.submit();
  };

  const getConsentRecipientName = (item) => {
    if (!item?.commentedBy) return "";
    return `${item.commentedBy.firstName || ""} ${item.commentedBy.lastName || ""}`.trim();
  };

  const formatPersonName = (person) => {
    if (!person) return "";
    return `${person.firstName || ""} ${person.lastName || ""}`.trim();
  };

  const getMessageInitiatorName = (item) => {
    if (item?.commentAsked) {
      return formatPersonName(item.commentAskedBy) || formatPersonName(item.commentedBy);
    }
    return formatPersonName(item.commentedBy);
  };

  const getMessageReplierName = (item) => {
    if (!item?.commentGiven || !item?.commentAsked) return "";
    return formatPersonName(item.commentedBy);
  };

  useEffect(() => {
    if (showChatModal && chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [showChatModal, data?.commentDetails, consent, commentFormKey]);

  const formatChatTime = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const hh = d.getHours();
    const mm = String(d.getMinutes()).padStart(2, "0");
    const ampm = hh >= 12 ? "PM" : "AM";
    return `${hh % 12 || 12}:${mm} ${ampm}`;
  };

  const formatChatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    if (d.toDateString() === today.toDateString()) return "Today";
    if (d.toDateString() === yesterday.toDateString()) return "Yesterday";
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  const renderFileLinks = (fileStr) => {
    if (!fileStr) return null;
    return fileStr.split(",").map((fileName, idx) => {
      const trimmed = fileName.trim();
      if (!trimmed) return null;
      return (
        <a
          key={idx}
          className="chat-attachment text-decoration-none"
          href={`${fileDownloadURL}/${trimmed}`}
          download={trimmed}
          target="_blank"
          rel="noreferrer"
        >
          <i className="ti ti-paperclip"></i>
          <span>{trimmed}</span>
          <i className="ti ti-download"></i>
        </a>
      );
    });
  };

  const isOutgoing = (roleStr) => {
    const r = getRole(roleStr);
    return r === "spoc" || r === "cst";
  };

  // const sladetailstoggle=()=>{

  // }
  return (
    <>
      <Card className="feedback-overview border-0 h-100">
        <ReactModal
          size="sm"
          componentToRender={
            <ShowResolverInfoModal
              open={isShowing}
              handleClose={toggle}
              handleUserList={row}
            />
          }
          show={isShowing}
          handleClose={toggle}
          title={t("general.label.user.list")}
        />
        {/* <ShowResolverInfoModal
          isShowing={isShowing}
          hide={toggle}
          handleUserList={row}
        /> */}
        <CardBody elevation={0}>
          <div className="right-action mb-1">
            {/* {currentStatus ? (<> <span className={`${getStatus(currentStatus)}-bg-color badge rounded-pill bg-primary`}> <i class="ti ti-folder-open"></i> {currentStatus}</span></>) : (<> <Skeleton animation={skeleton_animation_style_primary} variant="rounded" height={20} /></>)} */}

            {/* <span class="wip-bg-color badge rounded-pill bg-primary"> <i class="ti ti-folder-open"></i> Work in progress</span>
                  <span class="closed-bg-color badge rounded-pill bg-primary"> <i class="ti ti-folder-open"></i> Closed</span>
                     <span class="reopened-bg-color badge rounded-pill bg-primary"> <i class="ti ti-folder-open"></i> Reopened</span> */}
          </div>
          <h6 className="text-primary mb-0">
            {t("label.new.feedbacklist.feedbackCdoe")}:{" "}
            {feedbackCode ? (
              <span> {feedbackCode}</span>
            ) : (
              <>
                {" "}
                <Skeleton
                  animation={skeleton_animation_style_primary}
                  variant="rounded"
                  height={20}
                  className="mt-1"
                />
              </>
            )}
          </h6>
          {currentStatus ? (
            <>
              {/* <Typography className={styles.fontStyle}>
              {t('feedbackDetails.currentStatus.text')}: <span className={styles.fonttext}>{currentStatus}</span>
            </Typography> */}
              <div className="section">
                {feedbackType && (
                  <ul className="all-details ps-0">
                    <li>
                      <i class="ti ti-info-circle me-1"></i>
                      {t("report.page.aging.table.header.feedbacktype")}:{" "}
                      <span> {feedbackType}</span>
                    </li>
                    {/* <li>
              <i class="ti ti-building me-1"></i> {t('feedbackDetails.organizationName.text')}: <span>{organizationName}</span>
            </li>
            <li>
              <i class="ti ti-user-share me-1"></i> {t('feedbackDetails.feedbackGiven.text')}: <span>{feedbackGivenBy}</span>
            </li> */}
                    {/* <li>
              <i class="ti ti-mail me-1"></i> {t('general.label.email')}:  <span>{emailId}</span>
            </li> */}
                    {showAssigneGroup && (
                      <li>
                        <i class="ti ti-users me-1"></i>{" "}
                        {t("menu.key.master.group")}:{" "}
                        <span>
                          {data?.receiptDetails[0]?.assigneeGroup?.name || ""}{" "}
                          <i
                            class="ti ti-external-link fs-6 text-primary"
                            aria-hidden="true"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => handleAssigneeView(e)}
                          ></i>
                        </span>
                      </li>
                    )}
                  </ul>
                )}

                {/* {data?.latestReceipt && data.latestReceipt?.assigneeGroup && (
              <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#867FA1' }}>
                      <TableCell className={styles.tableHeight}>{t('general.label.serial.number.short')}</TableCell>
                      <TableCell className={styles.tableHeight}>{t('feedbackDetails.groupName.text')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>

                    <TableRow key={1}>
                      <TableCell>{1}</TableCell>
                      <TableCell>{data.latestReceipt.assigneeGroup.name}
                        <i class="fa fa-external-link" aria-hidden="true" onClick={(e) => handleAssigneeView(e)}></i></TableCell>
                      <TableCell></TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>
            )} */}
                {/* {data.receiptDetails && data.receiptDetails[0].assigneeGroup && (
              <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#867FA1' }}>
                      <TableCell className={styles.tableHeight}>{t('general.label.serial.number.short')}</TableCell>
                      <TableCell className={styles.tableHeight}>{t('feedbackDetails.groupName.text')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody> */}

                {/* <TableRow key={1}>
                      <TableCell>{1}</TableCell>
                      <TableCell>{data.receiptDetails[0].assigneeGroup.assigneName}
                        <i class="fa fa-external-link" aria-hidden="true" onClick={(e) => handleAssigneeView(e)}></i></TableCell> */}
                {/* <TableCell></TableCell> */}
                {/* </TableRow> */}

                {/* </TableBody>
                </Table>
              </TableContainer>
            )} */}
                {feedbackType && (
                  <ul className="all-details ps-0">
                    {/* <li>
              <i class="ti ti-device-mobile me-1"></i>{t('general.field.mobile.label')}: <span>{mobileNumber}</span>
            </li> */}
                    {/* <li>
              <i class="ti ti-phone me-1"></i>{t('general.field.phone.label')}: <span>{phoneNumber}</span>
            </li> */}
                    {/* <li>
              <i class="ti ti-map-pin me-1"></i>{t('feedbackDetails.address.text')}: <span>{address}</span>
            </li> */}
                    {client.map((clientItem, index) => (
                      <li key={index}>
                        <i class="ti ti-user-check me-1"></i>
                        {clientItem.attributeName}:{" "}
                        <span>{clientItem.attributeVal}</span>
                      </li>
                    ))}
                    <li>
                      <i class="ti ti-user-check me-1"></i>
                      {t("menu.key.master.feedbackSource")}:{" "}
                      <span>{feedbackSource}</span>
                    </li>
                    <li>
                      <i class="ti ti-user-check me-1"></i>
                      {t("feedbackDetails.createdBy.text")}:{" "}
                      <span>{createdBy}</span>
                    </li>
                    <li>
                      <i class="ti ti-calendar-event me-1"></i>
                      {t("label.new.feedbacklist.DateOfFeedback")}:{" "}
                      <span>{dateOfFeedback}</span>
                    </li>
                    {/* <li>
                <i class="ti ti-calendar-event me-1"></i>Target Date: <span>{generateAppropriateDate(data?.receiptDetails[0]?.targetTime)}</span>
              </li>
              <li>
                <i class="ti ti-calendar-event me-1"></i>{t('feedbackDetails.actualCloseDate.text')} <span>{generateAppropriateDate(data?.receiptDetails[0]?.cmltnDate)}</span>
              </li>
              <li>
                <i class="ti ti-calendar-event me-1"></i>{t('feedbackDetails.assignedTo.text')} <span>{data?.receiptDetails[0]?.assigneeGroup?.assigneName || 'N/A'}</span>
              </li>
               */}
                    {/* <li>
              <i class="ti ti-file-text me-1"></i>{t('feedbackDetails.feedbackDescription.text')}: <span dangerouslySetInnerHTML={{ __html: feedbackDescription }} />
            </li> */}
                  </ul>
                )}
                {showResolution && (
                  <>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="btn-rating py-1 lh-normal btn btn-secondary btn-sm m-0 mb-1"
                      onClick={handleClickResolution}
                    >
                      {t("general.tab.resolutionDetails.text")}
                    </Button>
                  </>
                )}
                {showRecipt && (
                  <>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="btn-rating py-1 lh-normal btn btn-secondary btn-sm m-0 mb-1"
                      onClick={handleClickRecipt}
                    >
                      {t("general.tab.receiptDetails.text")}
                    </Button>
                  </>
                )}
                {showSla && (
                  <>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="btn-rating py-1 lh-normal btn btn-secondary btn-sm m-0 mb-1"
                      onClick={handleSladetails}
                    >
                      {t("general.tab.slaDetails.text")}
                    </Button>
                    <br />
                  </>
                )}
                {showSla &&
                  data?.feedbackDetails?.status
                    .trim()
                    .localeCompare("Accepted", "en-US", {
                      sensitivity: "base",
                    }) === 0  && (["role_resolver"].includes(roles.toLowerCase()) || data?.feedbackDetails?.reopenedFeeebackResolvable) && (
                    <>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        className="btn-rating py-1 lh-normal btn btn-secondary btn-sm m-0 mb-1"
                        onClick={handleCloseFD}
                      >
                        {t("menu.key.feedback.close")}
                      </Button>
                      <br />
                    </>
                  )}

                {/* <Button
                  variant="outline-secondary"
                  size="sm"
                  className='custom-primary mb-2'
                  onClick={handleSladetails}
                >
                  {t('general.tab.slaDetails.text')}
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className='custom-primary mb-2'
                  onClick={handleClickRecipt}
                >
                  {t('general.tab.receiptDetails.text')}
                </Button> */}

                {/* <br></br> */}
                {/* <button onClick={handleClickResolution}>Resolution Details</button> */}
                {rateCheck && (
                  <>
                    <button
                      type="button"
                      onClick={() => handleClick()}
                      class="btn-rating py-1 lh-normal btn btn-secondary btn-sm m-0 mb-1 rate-now-btn"
                    >
                      <i class="ti ti-star orange-color icon-small fs-6 me-1"></i>
                      {t("general.label.rate.now")}
                    </button>{" "}
                    <br />
                  </>
                )}
                {/* {customerStatisfactionStored && Array.from({ length: customerStatisfactionStored }, (_, i) => (
                  <i
                    className={`ti ti-star-filled star-${customerStatisfactionStored} icon-small fs-6`}
                    key={i}
                    onClick={handleCustomerSatisfactionStar}
                  ></i>
                ))}
                {Array.from({ length: 5 - (customerStatisfactionStored || 0) }, (_, j) => (
                  <i
                    className={`ti ti-star star-${customerStatisfactionStored} icon-small fs-6`}
                    key={j}
                    onClick={handleCustomerSatisfactionStar}
                  ></i>
                ))} */}
                {reopenReasonList?.map(
                  (reason, index) =>
                    index === 0 && (
                      <span key={index}>
                        {reason?.feedbackSatisfaction?.id && (
                          <>
                            <button
                              type="button"
                              className="btn-rating after-rated py-1 lh-normal btn btn-secondary btn-sm m-0"
                              onClick={handleCustomerSatisfactionStar}
                            >
                              <span>
                                {reason?.feedbackSatisfaction?.id < 10 ? (
                                  <>
                                    {Array.from(
                                      {
                                        length:
                                          reason?.feedbackSatisfaction?.id,
                                      },
                                      (_, i) => (
                                        <i
                                          className={`ti ti-star-filled star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`}
                                          key={i}
                                          onClick={
                                            handleCustomerSatisfactionStar
                                          }
                                        ></i>
                                      )
                                    )}
                                    {Array.from(
                                      {
                                        length:
                                          5 -
                                          (reason?.feedbackSatisfaction?.id ||
                                            0),
                                      },
                                      (_, j) => (
                                        <i
                                          className={`ti ti-star star-${reason?.feedbackSatisfaction?.id} icon-small fs-6`}
                                          key={j}
                                          onClick={
                                            handleCustomerSatisfactionStar
                                          }
                                        ></i>
                                      )
                                    )}
                                  </>
                                ) : reason?.feedbackSatisfaction?.id === 100 ? (
                                  <>
                                    {Array.from({ length: 5 }, (_, i) => (
                                      <i
                                        className={`ti ti-star-filled star-5 icon-small fs-6`}
                                        key={i}
                                        onClick={handleCustomerSatisfactionStar}
                                      ></i>
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    {Array.from({ length: 3 }, (_, i) => (
                                      <i
                                        className={`ti ti-star-filled star-3 icon-small fs-6`}
                                        key={i}
                                        onClick={handleCustomerSatisfactionStar}
                                      ></i>
                                    ))}
                                    <i
                                      className={`ti ti-star star-3 icon-small fs-6`}
                                      // key={i}
                                      onClick={handleCustomerSatisfactionStar}
                                    ></i>{" "}
                                    <i
                                      className={`ti ti-star star-3 icon-small fs-6`}
                                      // key={i}
                                      onClick={handleCustomerSatisfactionStar}
                                    ></i>
                                    {/* <i
                                className={`ti ti-star-filled star-empty icon-small fs-6`}
                                // key={i}
                                onClick={handleCustomerSatisfactionStar}
                              ></i> */}
                                  </>
                                )}
                              </span>
                            </button>
                          </>
                        )}
                        {/* {reason?.feedbackSatisfaction?.reason && (
                      <span>
                        <p>
                          {reason.feedbackSatisfaction.reason && (
                            <span>
                              {(() => {
                                try {
                                  const jsonReason = JSON.parse(reason.feedbackSatisfaction.reason);
                                  if (Array.isArray(jsonReason)) {
                                    return jsonReason.map((item, index) => (
                                      <div key={index}>
                                        <span>{item.deSatisfactionReason}</span>
                                      </div>
                                    ));
                                  } else {
                                    // Handle the case where JSON is not an array
                                    return <span>{jsonReason}</span>;
                                  }
                                } catch (error) {
                                  // If parsing fails, treat it as a regular string
                                  return <span>{reason.feedbackSatisfaction.reason}</span>;
                                }
                              })()}
                            </span>
                          )}
                        </p>
                      </span>
                    )} */}
                      </span>
                    )
                )}
              </div>
            </>
          ) : (
            <>
              {/* <Skeleton animation={skeleton_animation_style_primary} variant="rounded" className='mb-1' /> */}

              <Skeleton
                animation={skeleton_animation_style_primary}
                variant="rounded"
                height={100}
                className="mt-1"
              />
            </>
          )}

          {/* <hr className='border-dashed border-blue opacity-100'></hr> */}

          <div className="section">
            <h5 className="mb-3">{t("general.label.tagged.feedback")}:</h5>
            <ul className="tag-details ps-0">
              {feedbackType ? (
                <>
                  {data?.taggedFeedbackList &&
                  data?.taggedFeedbackList.length > 0 ? (
                    <li className="text-primary">
                      <i className="ti ti-external-link me-1 "></i>
                      <span className="fs-7">{generateTaggedFeedbacks()}</span>
                    </li>
                  ) : (
                    <>
                      {/* <Skeleton variant="rounded" className='mb-1' />
                      <Skeleton variant="rounded" height={100} /> */}
                      {/* <Skeleton animation={skeleton_animation_style_primary} variant="rounded" className='mb-1' />
                      <Skeleton animation={skeleton_animation_style_primary} variant="rounded" height={100} /> */}
                      <li>{t("general.label.notagged.feedback")}</li>
                    </>
                  )}
                </>
              ) : (
                <>
                  {/* <Skeleton animation={skeleton_animation_style_primary} variant="rounded" className='mb-1' /> */}
                  <Skeleton
                    animation={skeleton_animation_style_primary}
                    variant="rounded"
                    height={100}
                  />
                  {/* <li>{t('general.label.notagged.feedback')}</li> */}
                </>
              )}
            </ul>
          </div>

          {showCustomerConsent && (
        <div className="section history-info">
          {/* Check if feedbackType is true */}
          <h5 className="mb-3">{t('general.label.customerResponse.feedback')}:</h5>
          <Button
            variant="outline-secondary"
            size="sm"
            className="mb-2"
            onClick={handleOpenPopup}
          >
            {t('general.lable.customerResponse.text')}
          </Button>
        </div>
      )}

      {/* Show the popup modal */}
      {showPopup && <CustomerResponsePopup onClose={handleClosePopup} t={t} customerResponseFormData={customerResponseFormData} handleMailData= {handleMailData} fetchfeedbackDetails={fetchfeedbackDetails}/>}


          {showConsent && (
            <>
              <div className="section history-info">
                {feedbackType ? (
                  <>
                    <h5 className="mb-3">
                      {t("general.label.consent.feedback")}:
                    </h5>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="mb-2"
                      onClick={openChatModal}
                    >
                      <i className="ti ti-message-2 me-1"></i>
                      {t("general.label.comment.details")}
                    </Button>
                    <ul class="timeline">
                      {/* <li class="timeline-item customer">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <Card className="border-0">
                      <CardBody className="p-0">
                        <p className='mb-2 fs-6'>dmmy text dmmy text dmmy text dmmy text dmmy text</p>
                        <Button variant="outline-secondary" size="sm" className='mb-2'>
                          Consent
                        </Button>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </li> */}

                      {getCommentDetailsList().map((item) => (
                          <li
                            key={item.id}
                            className={`timeline-item ${
                              getRole(
                                item?.commentDetais?.commentedAskedbyRole
                                  ?.description
                              ) || getRole(item?.commentedByRole?.description)
                            }`}
                          >
                            <div className="timeline-body">
                              <div className="timeline-content">
                                <Card className="border-0">
                                  <CardBody className="p-0">
                                    {item.status === "A" &&
                                      item.commentAsked && (
                                        <>
                                          <p className="mb-2 fs-7 text-break lh-normal">
                                            <span className="fw-semibold mt-1">
                                              {item.commentAskedBy.firstName}{" "}
                                              {item.commentAskedBy.lastName}
                                            </span>
                                            <br />
                                            <span>
                                              {generateAppropriateDateWithConsent(
                                                item.createDate
                                              )}{" "}
                                              {item.consentAddFile && (
                                                <a
                                                  //key={index}
                                                  className="file text-decoration-none mt-2"
                                                  href={
                                                    fileDownloadURL +
                                                    "/" +
                                                    item.consentAddFile
                                                  } // Assuming each file object in data contains a filePath property
                                                  download={item.consentAddFile} // Assuming each file object in data contains a fileName property
                                                  target="_blank"
                                                  rel="noreferrer"
                                                >
                                                  <span className="ps-2">
                                                    <i class="ti ti-download fs-6"></i>
                                                  </span>
                                                </a>
                                              )}
                                            </span>
                                          </p>

                                          {item.commentAsked && (
                                            <hr className="w-50 my-2"></hr>
                                          )}

                                          {item.commentAsked && (
                                            <p className="text-break fs-7">
                                              {item.commentAsked}
                                            </p>
                                          )}
                                          {/* <hr className="w-100 my-2"></hr> */}
                                          {item.commentAsked && (
                                            <div className="px-3">
                                              <p className="mb-2 fs-7 text-break lh-normal">
                                                <span className="fw-semibold mt-1">
                                                  {item.commentedBy.firstName}{" "}
                                                  {item.commentedBy.lastName}
                                                </span>
                                                <br />
                                                <span>
                                                  {generateAppropriateDateWithConsent(
                                                    item.updateDate
                                                  )}{" "}
                                                  {item.provideConsentFile && (
                                                    <a
                                                      //key={index}
                                                      className="file text-decoration-none mt-2"
                                                      href={
                                                        fileDownloadURL +
                                                        "/" +
                                                        item.provideConsentFile
                                                      } // Assuming each file object in data contains a filePath property
                                                      download={
                                                        item.provideConsentFile
                                                      } // Assuming each file object in data contains a fileName property
                                                      target="_blank"
                                                      rel="noreferrer"
                                                    >
                                                      <span className="ps-2">
                                                        <i class="ti ti-download fs-6"></i>
                                                      </span>
                                                    </a>
                                                  )}
                                                </span>
                                              </p>

                                              {item.commentGiven && (
                                                <hr className="w-50 my-2"></hr>
                                              )}

                                              {item.commentGiven && (
                                                <p className="text-break fs-7">
                                                  {item.commentGiven}
                                                </p>
                                              )}
                                            </div>
                                          )}
                                        </>
                                      )}
                                    {item.status === "W" && (
                                      <>
                                        <p className="mb-2 fs-7 text-break lh-normal">
                                          <span className="fw-semibold mt-1">
                                            {item.commentAskedBy.firstName}{" "}
                                            {item.commentAskedBy.lastName}
                                          </span>
                                          <br />
                                          <span>
                                            {generateAppropriateDateWithConsent(
                                              item.createDate
                                            )}{" "}
                                            {/* {item.consentAddFile && (
                                              <a
                                                //key={index}
                                                className="file text-decoration-none mt-2"
                                                href={
                                                  fileDownloadURL +
                                                  "/" +
                                                  item.consentAddFile
                                                } // Assuming each file object in data contains a filePath property
                                                download={item.consentAddFile} // Assuming each file object in data contains a fileName property
                                                target="_blank"
                                                rel="noreferrer"
                                              >
                                                <span className="ps-2">
                                                  <i class="ti ti-download fs-6"></i>
                                                </span>
                                              </a>
                                            )} */}
                                            <Row>
                                            {item.consentAddFile && item.consentAddFile
                                              .split(',')
                                              .map((fileName, index) => {
                                                const trimmedName = fileName.trim();
                                                if (!trimmedName) return null;
                                                  return(
                                                <a
                                                  //key={index}
                                                  className="file text-decoration-none mt-2"
                                                  href={`${fileDownloadURL}/${trimmedName}`}// Assuming each file object in data contains a filePath property
                                                  download={trimmedName} // Assuming each file object in data contains a fileName property
                                                  target="_blank"
                                                  rel="noreferrer"
                                                >
                                                  <span className="ps-2">
                                                    {trimmedName}<i class="ti ti-download fs-6"></i>
                                                  </span>
                                                </a>);
                                              })}
                                              </Row>
                                          </span>
                                        </p>
                                        {item.commentAsked && (
                                          <hr className="w-50 my-2"></hr>
                                        )}
                                        {item.commentAsked && (
                                          <p className="text-break fs-7">
                                            {item.commentAsked}
                                          </p>
                                        )}
                                      </>
                                    )}
                                    {item.status === "A" &&
                                      !item.commentAsked && (
                                        <>
                                          <p className="mb-2 fs-7 text-break lh-normal">
                                            <span className="fw-semibold mt-1">
                                              {item.commentedBy.firstName}{" "}
                                              {item.commentedBy.lastName}
                                            </span>
                                            <br />
                                            <span>
                                              {generateAppropriateDateWithConsent(
                                                item.createDate
                                              )}{" "}
                                            <Row>
                                            {item.commentAddFile && item.commentAddFile
                                              .split(',')
                                              .map((fileName, index) => {
                                                const trimmedName = fileName.trim();
                                                if (!trimmedName) return null;
                                                  return(
                                                <a
                                                  //key={index}
                                                  className="file text-decoration-none mt-2"
                                                  href={`${fileDownloadURL}/${trimmedName}`}// Assuming each file object in data contains a filePath property
                                                  download={trimmedName} // Assuming each file object in data contains a fileName property
                                                  target="_blank"
                                                  rel="noreferrer"
                                                >
                                                  <span className="ps-2">
                                                    {trimmedName}<i class="ti ti-download fs-6"></i>
                                                  </span>
                                                </a>);
                                              })}
                                              </Row>
                                            </span>
                                          </p>
                                          {item.commentGiven && (
                                            <hr className="w-50 my-2"></hr>
                                          )}
                                          {item.commentGiven && (
                                            <p className="text-break fs-7">
                                              {item.commentGiven}
                                            </p>
                                          )}
                                        </>
                                      )}
                                    {/* {true && (
                                      <>
                                        <p className="mb-2 fs-7 text-break lh-normal">
                                          <span className="fw-semibold mt-1">
                                            {item.commentedBy.firstName}{" "}
                                            {item.commentedBy.lastName}
                                          </span>
                                          <span className="fw-semibold mt-1">
                                            {item?.commentAskedBy?.firstName}{" "}
                                            {item?.commentAskedBy?.lastName}
                                          </span>
                                          <br />
                                          <span>
                                            {generateAppropriateDateWithConsent(
                                              item.updateDate
                                            )}
                                          </span>
                                          {item.consentAddFile && (
                                            <a
                                              //key={index}
                                              className="file text-decoration-none mt-2"
                                              href={
                                                fileDownloadURL +
                                                "/" +
                                                item.consentAddFile
                                              } // Assuming each file object in data contains a filePath property
                                              download={item.consentAddFile} // Assuming each file object in data contains a fileName property
                                              target="_blank"
                                            >
                                              <span className="ps-2">
                                                <i class="ti ti-download fs-6"></i>
                                              </span>
                                            </a>
                                          )}
                                        </p>

                                        {item.commentGiven && (
                                          <hr className="w-50 my-2"></hr>
                                        )}
                                      </>
                                    )} */}
                                    {/* {item.commentGiven && (
                                      <p className="text-break fs-7">
                                        {item.commentGiven}
                                        {(item.commentAddFile ||
                                          item.provideConsentFile) && (
                                          <a
                                            //key={index}
                                            className="file text-decoration-none mt-2"
                                            href={
                                              fileDownloadURL +
                                              "/" +
                                              (item.commentAddFile
                                                ? item.commentAddFile
                                                : item.provideConsentFile)
                                            } // Assuming each file object in data contains a filePath property
                                            download={
                                              item?.commentAddFile
                                                ? item.commentAddFile
                                                : item.provideConsentFile
                                            } // Assuming each file object in data contains a fileName property
                                            target="_blank"
                                          >
                                            <span className="ps-2">
                                              <i class="ti ti-download fs-6"></i>
                                            </span>
                                          </a>
                                        )}
                                      </p>
                                    )} */}

                                    {item.commentAsked &&
                                      !item.commentGiven &&
                                      item?.commentedBy?.id === userId && (
                                        <Button
                                          variant="outline-secondary"
                                          size="sm"
                                          className="mb-2"
                                          onClick={() =>
                                            openChatModalForConsent(item.id)
                                          }
                                        >
                                          {t("general.lable.consent.text")}
                                        </Button>
                                      )}
                                  </CardBody>
                                </Card>
                              </div>
                            </div>
                          </li>
                        ))}
                      {/* {consentDataDetails?.commentDetails
                  ?.filter((item, index, self) => self.findIndex(t => t.id === item.id) === index) // Filter out duplicate items based on item.id
                  .map(item => (
                    <li key={item.id} className={`timeline-item ${getRole(item?.commentDetais?.commentedAskedbyRole?.description) || getRole(item?.commentedByRole?.description)}`}>
                      <div className="timeline-body">
                        <div className="timeline-content">
                          <Card className="border-0">
                            <CardBody className="p-0">
                              {item.commentAsked && (
                                <>
                                  <p className='mb-2 fs-6'>{item.commentAsked}</p>
                                  {item.commentGiven && (
                                    <h3 style={{ borderBottom: '1px solid', paddingBottom: '6px', width: '40%' }}></h3>
                                  )}
                                </>
                              )}
                              {item.commentGiven && (

                                <p>{item.commentGiven}</p>
                              )}

                              {item.commentAsked && !item.commentGiven && data.commentDetails.some(comment =>
                                comment.status === 'W' &&
                                comment.commentedBy != null &&
                                comment.commentedBy.id === comment.signInUser.id &&
                                comment.commentGiven == null
                              ) && (
                                  <Button variant="outline-secondary" size="sm" className='mb-2' onClick={() => ConsentCommenttagged(item.id)}>
                                    Consent
                                  </Button>
                                )}

                            </CardBody>
                          </Card>
                        </div>
                      </div>
                    </li>
                  ))} */}

                      {/* <li class="timeline-item spoc">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <Card className="border-0">
                      <CardBody className="p-0">
                        <p className='mb-2 fs-6'>dmmy text dmmy text dmmy text dmmy text dmmy text dmmy text dmmy text</p>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </li> */}

                      {/* <li class="timeline-item cst">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <Card className="border-0">
                      <CardBody className="p-0">
                        <p className='mb-2 fs-6'>dmmy text dmmy text dmmy text dmmy text dmmy text dmmy text dmmy text</p>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </li> */}
                    </ul>
                  </>
                ) : (
                  <>
                    <Skeleton
                      animation={skeleton_animation_style_primary}
                      variant="rounded"
                      height={100}
                    />
                  </>
                )}
              </div>
            </>
          )}
        </CardBody>
        <Dialog open={isOpen} onClose={toggleModal}>
          <DialogTitle>{t("general.lable.feedbackDetail.text")}</DialogTitle>
          <DialogContent>
            {selectedTaggedFeedbackId !== null && ( // Check if a feedback is selected
              <ViewFeedbackDetails
                data={selectedTaggedFeedbackId}
                fetchUrl={selectedTaggedFeedbackId}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleModal} color="primary">
              {t("general.button.panel.footer.close")}
            </Button>
          </DialogActions>
        </Dialog>

        {/* WhatsApp-style Comment Chat Modal */}
        <Dialog
          open={showChatModal}
          onClose={closeChatModal}
          fullWidth
          maxWidth="md"
          className="comment-chat-modal"
          PaperProps={{ style: { borderRadius: 14, overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '90vh', maxHeight: '90vh' } }}
        >
          {/* Header */}
          <div className="comment-chat-header">
            <div className="chat-header-avatar">
              <i className="ti ti-message-2"></i>
            </div>
            <div>
              <p className="chat-header-title">{t("general.label.comment.details")}</p>
            </div>
            <IconButton className="close-btn" onClick={closeChatModal} size="small">
              <i className="ti ti-x fs-6"></i>
            </IconButton>
          </div>

          {/* Chat Body — 60% of modal height */}
          <div className="comment-chat-body">
            {getChatCommentItems().length === 0 ? (
              <div className="chat-empty-state">
                <i className="ti ti-messages"></i>
                <p>{t("general.label.no.comments") || "No comment history yet."}</p>
                <small>Use the form below to add the first comment.</small>
              </div>
            ) : (
              (() => {
                const items = getChatCommentItems().filter(
                  (item, index, self) => self.findIndex((t) => t.id === item.id) === index
                );
                let lastDateLabel = "";
                return items.map((item) => {
                  // For ask/consent bubble: whoever asked is the initiator
                  // For plain comment (no commentAsked): commentedBy is the author
                  const initiatorId = item.commentAsked
                    ? item?.commentAskedBy?.id
                    : item?.commentedBy?.id;
                  const replierId = item?.commentedBy?.id;
                  const askedOutgoing = String(initiatorId) === String(userId);
                  const replyOutgoing = String(replierId) === String(userId);
                  const askedDate = formatChatDate(item.createDate);
                  const repliedDate = formatChatDate(item.updateDate);
                  const showDateSep = askedDate && askedDate !== lastDateLabel;
                  if (showDateSep) lastDateLabel = askedDate;

                  return (
                    <React.Fragment key={item.id}>
                      {showDateSep && (
                        <div className="chat-date-separator">
                          <span>{askedDate}</span>
                        </div>
                      )}

                      {/* Asked / Comment bubble */}
                      {(item.status === "W" || (item.status === "A" && item.commentAsked)) && (
                        <div className={`chat-bubble-row ${askedOutgoing ? "outgoing" : "incoming"}`}>
                          <div className={`chat-bubble ${askedOutgoing ? "outgoing" : "incoming"}`}>
                            <span className="bubble-sender">
                              {getMessageInitiatorName(item)}
                            </span>
                            {item.commentAsked && (
                              <p className="bubble-text">{item.commentAsked}</p>
                            )}
                            {/* Files for status W */}
                            {item.status === "W" && renderFileLinks(item.consentAddFile)}
                            <div className="bubble-meta">
                              <span className="bubble-time">{formatChatTime(item.createDate)}</span>
                              <span className={`chat-status-badge ${item.status === "W" ? "waiting" : "answered"}`}>
                                {item.status === "W"
                                  ? `${t("general.lable.consent.text")}${getConsentRecipientName(item) ? ` - ${getConsentRecipientName(item)}` : ""}`
                                  : "Answered"}
                              </span>
                            </div>
                          </div>
                          {/* Consent reply button for pending items */}
                          {item.status === "W" && item.commentAsked && !item.commentGiven && item?.commentedBy?.id === userId && (
                            <button
                              className="chat-consent-btn"
                              onClick={() => openChatModalForConsent(item.id)}
                            >
                              <i className="ti ti-corner-up-left"></i>
                              {t("general.lable.consent.text")}
                            </button>
                          )}
                        </div>
                      )}

                      {/* Status A with commentAsked – show reply too */}
                      {item.status === "A" && item.commentAsked && item.commentGiven && (
                        <>
                          <div className="chat-thread-line"></div>
                          <div className={`chat-bubble-row ${replyOutgoing ? "outgoing" : "incoming"}`}>
                            <div className={`chat-bubble ${replyOutgoing ? "outgoing" : "incoming"}`}>
                              <span className="bubble-sender">
                                {getMessageReplierName(item)}
                              </span>
                              <p className="bubble-text">{item.commentGiven}</p>
                              {renderFileLinks(item.provideConsentFile)}
                              <div className="bubble-meta">
                                <span className="bubble-time">{formatChatTime(item.updateDate)}</span>
                                <span className="chat-status-badge answered">Replied</span>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {/* Status A without commentAsked – standalone comment */}
                      {item.status === "A" && !item.commentAsked && (
                        <div className={`chat-bubble-row ${askedOutgoing ? "outgoing" : "incoming"}`}>
                          <div className={`chat-bubble ${askedOutgoing ? "outgoing" : "incoming"}`}>
                            <span className="bubble-sender">
                              {item.commentedBy ? `${item.commentedBy.firstName} ${item.commentedBy.lastName}` : ""}
                            </span>
                            {item.commentGiven && <p className="bubble-text">{item.commentGiven}</p>}
                            {renderFileLinks(item.commentAddFile)}
                            <div className="bubble-meta">
                              <span className="bubble-time">{formatChatTime(item.createDate)}</span>
                              <span className="chat-status-badge answered">Comment</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  );
                });
              })()
            )}
            <div ref={chatEndRef} />
          </div>

          {/* Reply + Footer — 40% of modal height */}
          <div className="comment-chat-form-panel">
            <div className="comment-chat-reply">
              <div className="reply-header">
                <i className={`ti ${chatConsentTagged ? "ti-send" : "ti-corner-up-left"}`}></i>
                <span>
                  {chatConsentTagged
                    ? t("general.label.add.comment")
                    : t("general.lable.consent.text")}
                </span>
              </div>
              <div className="comment-chat-reply-inner">
                <CommentDetails
                  ref={commentFormRef}
                  key={`comment-form-${commentFormKey}-${chatConsentTagged ? "add" : `consent-${chatConsentId}`}`}
                  data={data}
                  consentDetails={handleChatConsentSubmit}
                  consentTaggeddata={chatConsentTagged}
                  consentID={chatConsentId}
                  footerSubmit
                  onFormStateChange={handleCommentFormStateChange}
                />
              </div>
            </div>
            <div className="comment-chat-footer">
              <MuiButton
                variant="contained"
                onClick={handleChatFormSubmit}
                className="text-capitalize comment-chat-submit-btn"
                disabled={!commentFormState.canSubmit || commentFormState.isSubmitting}
              >
                <span className="comment-chat-submit-content">
                  {commentFormState.isSubmitting ? (
                    <>
                      <CircularProgress size={15} color="inherit" className="comment-chat-submit-spinner" />
                      <span>{t("general.button.submitting.label") || "Submitting..."}</span>
                    </>
                  ) : (
                    <span>{t("general.button.submit.label")}</span>
                  )}
                </span>
              </MuiButton>
            </div>
          </div>
        </Dialog>

        <PluginSnackbar
          open={chatToast.open}
          message={chatToast.message}
          severity={chatToast.severity}
          onClose={() => setChatToast((prev) => ({ ...prev, open: false }))}
        />
      </Card>
      {showRate && (
        <CustomerSatisfaction
          isStarEnabled={data.startEnabled}
          data={data}
        ></CustomerSatisfaction>
      )}
    </>
  );
};

export default FeedBackDetails;
